var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.704961,-0.117493)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.495,
    cy: 39.772,
    rx: 3.055,
    ry: 3.231,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7.98956,6.34465)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.495,
    cy: 39.772,
    rx: 3.055,
    ry: 3.231,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.704961,13.8642)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.495,
    cy: 39.772,
    rx: 3.055,
    ry: 3.231,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.34465,6.34465)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.495,
    cy: 39.772,
    rx: 3.055,
    ry: 3.231,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18868,0,0,1.18942,-5.29287,-10.7717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.675,41.21C28.675,40.351 27.977,39.654 27.118,39.654L24.005,39.654C23.145,39.654 22.448,40.351 22.448,41.21L22.448,55.311C22.448,56.17 23.145,56.867 24.005,56.867L27.118,56.867C27.977,56.867 28.675,56.17 28.675,55.311L28.675,41.21Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00139499,1.18868,-1.18942,-0.00139586,82.5289,16.3134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.675,41.21C28.675,40.351 27.977,39.654 27.118,39.654L24.005,39.654C23.145,39.654 22.448,40.351 22.448,41.21L22.448,55.311C22.448,56.17 23.145,56.867 24.005,56.867L27.118,56.867C27.977,56.867 28.675,56.17 28.675,55.311L28.675,41.21Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.05744,-1.34726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,6.286C53.701,5.216 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,5.216 45.946,6.286L45.946,27.552C45.946,28.622 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.622 53.701,27.552L53.701,6.286Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00183131,0.984593,-1.49542,-0.00278143,89.2025,-24.1486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,5.624C53.701,4.919 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,4.919 45.946,5.624L45.946,28.214C45.946,28.919 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.919 53.701,28.214L53.701,5.624Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.984592,-0.00226602,0.00367374,-1.59625,143.196,82.9506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,5.543C53.701,4.883 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,4.883 45.946,5.543L45.946,28.295C45.946,28.955 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.955 53.701,28.295L53.701,5.543Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.011962,0.984522,-0.8116,-0.00986101,94.7904,32.7503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,6.699C53.701,5.401 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,5.401 45.946,6.699L45.946,27.139C45.946,28.437 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.437 53.701,27.139L53.701,6.699Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.627146,0.759022,-0.311598,0.25746,64.7147,37.1902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,9.07C53.701,6.463 51.261,-5.141 50.191,-5.141L47.885,4.347C46.815,4.347 45.946,6.463 45.946,9.07L45.946,24.769C45.946,27.375 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,27.375 53.701,24.769L53.701,9.07Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.542349,-0.821757,0.436419,0.288031,52.1697,63.9983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,9.07C53.701,6.463 51.261,-5.141 50.191,-5.141L47.885,4.347C46.815,4.347 45.946,6.463 45.946,9.07L45.946,24.769C45.946,27.375 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,27.375 53.701,24.769L53.701,9.07Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761154,-0.624558,0.231613,0.282268,49.7193,58.8256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,9.07C53.701,6.463 51.261,-5.141 50.191,-5.141L47.885,4.347C46.815,4.347 45.946,6.463 45.946,9.07L45.946,24.769C45.946,27.375 46.815,29.491 47.885,29.491L51.472,38.975C52.178,35.812 53.701,27.375 53.701,24.769L53.701,9.07Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.011962,0.984522,-0.8116,-0.00986101,64.3275,17.5106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,6.699C53.701,5.401 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,5.401 45.946,6.699L45.946,27.139C45.946,28.437 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.437 53.701,27.139L53.701,6.699Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.726576,0.664466,-0.690809,-0.755381,114.184,53.6105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,6.212C53.701,5.183 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,5.183 45.946,6.212L45.946,27.626C46.347,28.775 48.404,30.799 48.916,30.632L51.762,29.491C52.832,29.491 53.701,28.655 53.701,27.626L53.701,6.212Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00183131,0.984593,1.49542,-0.00278143,9.97724,-24.1486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,5.624C53.701,4.919 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,4.919 45.946,5.624L45.946,28.214C45.946,28.919 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.919 53.701,28.214L53.701,5.624Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.984592,-0.00226602,-0.00367374,-1.59625,-44.0165,82.9506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,5.543C53.701,4.883 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,4.883 45.946,5.543L45.946,28.295C45.946,28.955 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.955 53.701,28.295L53.701,5.543Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.011962,0.984522,0.8116,-0.00986101,4.38934,32.7503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,6.699C53.701,5.401 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,5.401 45.946,6.699L45.946,27.139C45.946,28.437 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.437 53.701,27.139L53.701,6.699Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.627146,0.759022,0.311598,0.25746,34.4651,37.1902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,9.07C53.701,6.463 51.261,-5.141 50.191,-5.141L47.885,4.347C46.815,4.347 45.946,6.463 45.946,9.07L45.946,24.769C45.946,27.375 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,27.375 53.701,24.769L53.701,9.07Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.542349,-0.821757,-0.436419,0.288031,47.0101,63.9983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,9.07C53.701,6.463 51.261,-5.141 50.191,-5.141L47.885,4.347C46.815,4.347 45.946,6.463 45.946,9.07L45.946,24.769C45.946,27.375 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,27.375 53.701,24.769L53.701,9.07Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.761154,-0.624558,-0.231613,0.282268,49.4604,58.8256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,9.07C53.701,6.463 51.261,-5.141 50.191,-5.141L47.885,4.347C46.815,4.347 45.946,6.463 45.946,9.07L45.946,24.769C45.946,27.375 46.815,29.491 47.885,29.491L51.472,38.975C52.178,35.812 53.701,27.375 53.701,24.769L53.701,9.07Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.011962,0.984522,0.8116,-0.00986101,34.8523,17.5106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,6.699C53.701,5.401 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,5.401 45.946,6.699L45.946,27.139C45.946,28.437 46.815,29.491 47.885,29.491L51.762,29.491C52.832,29.491 53.701,28.437 53.701,27.139L53.701,6.699Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.726576,0.664466,0.690809,-0.755381,-15.0044,53.6105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.701,6.212C53.701,5.183 52.832,4.347 51.762,4.347L47.885,4.347C46.815,4.347 45.946,5.183 45.946,6.212L45.946,27.626C46.347,28.775 48.404,30.799 48.916,30.632L51.762,29.491C52.832,29.491 53.701,28.655 53.701,27.626L53.701,6.212Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/Credits.eb6b199285274ee12618093fb693dd85.svg";
export { ForwardRef as ReactComponent };